import(/* webpackMode: "eager", webpackExports: ["BlogDetail"] */ "/vercel/path0/src/components/Blog/BlogDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeLayout"] */ "/vercel/path0/src/components/Layouts/HomeLayout.tsx");
